import {
  REPORTS,
  RPT_APPRAISAL,
  RPT_ATTN_SUMMARY,
  RPT_EMPLOYEE,
  RPT_MONTHLY_ATTENDANCE,
  RPT_PAYROLL,
  RPT_PF,
  RPT_GF,
  RPT_TAX_CERT,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

export const ReportsRoutes: IAppRoutes = {
  link: REPORTS,
  childrens: [
    {
      link: RPT_EMPLOYEE,
      element: guard(() => import('@modules/report/employee'), [RPT_EMPLOYEE]),
    },
    {
      link: RPT_APPRAISAL,
      element: guard(() => import('@modules/report/appraisal'), [RPT_APPRAISAL]),
    },
    {
      link: RPT_PAYROLL,
      element: guard(() => import('@modules/report/payroll'), [RPT_PAYROLL]),
    },
    {
      link: RPT_ATTN_SUMMARY,
      element: guard(() => import('@modules/report/attn-leave-summary'), [RPT_ATTN_SUMMARY]),
    },
    {
      link: RPT_MONTHLY_ATTENDANCE,
      element: guard(() => import('@modules/report/monthly-attendance'), [RPT_MONTHLY_ATTENDANCE]),
    },
    {
      link: RPT_PF,
      element: guard(() => import('@modules/report/pf'), [RPT_PF]),
    },
    {
      link: RPT_GF,
      element: guard(() => import('@modules/report/gf'), [RPT_GF]),
    },
    {
      link: RPT_TAX_CERT,
      element: guard(() => import('@modules/report/tax-certificate'), [RPT_TAX_CERT]),
    },
  ],
}
